import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot } from "@angular/router";
import { AuthService } from "@services/auth/auth.service";

@Injectable({
    providedIn: 'root'
})
export class userGuard implements CanActivate {
    uiService: any;
    router: any;

    constructor(
        private authSrv: AuthService,

    ) { }

    public canActivate(route: ActivatedRouteSnapshot) {
        let role = this.authSrv.getDecodedToken()?.role;
        if (role !== 'Administration$User') {
            return true;
        }

        this.uiService.showSnackbar('You do not have access to this application');
        this.router.navigate(['/choose-appli']);

        return false;
    }
}
